import { createContext } from 'react'
import type { Theme } from '@mui/material/styles'
import type { ResolvedTheme, ThemeMode } from './types'

export interface ThemeContextValue {
  readonly mode: ThemeMode
  readonly resolvedTheme: ResolvedTheme
  readonly theme: Theme
  readonly setMode: (mode: ThemeMode) => void
}

export const ThemeContext = createContext<ThemeContextValue | undefined>(undefined)
